<template>
  <v-sheet max-width="750" class="mx-auto mt-md-16">
    <v-card>
      <v-card-title>Informações de Contato</v-card-title>
      <v-card-text>
        <v-form v-model="valid" fast-fail @submit.prevent="submit">
          <v-text-field
            v-model="phone"
            v-mask="['(##) ####-####', '(##) # ####-####']"
            label="Telefone"
            placeholder="(67) 9 9999-9999"
            required
            :rules="phoneRules"
            type="tel"
          />
          <v-text-field
            v-model="email"
            label="Email"
            required
            :rules="emailRules"
          />
          <v-btn
            type="submit"
            color="secondary"
            block
            class="mt-2"
            :disabled="!valid"
          >
            ENVIAR
          </v-btn>
          <v-alert class="mt-2" type="success" :value="alert">
            Informações de contato enviadas
          </v-alert>
        </v-form>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
import Collaborator from "../../services/collaborator-service";
import { mask } from "vue-the-mask";

export default {
  name: "ContactInfo",
  directives: { mask },
  data() {
    return {
      alert: false,
      contact: {},
      phone: "",
      email: "",
      valid: false,
      phoneRules: [
        (v) => !!v || "Informe seu número de telefone",
        (v) =>
          /^(?:\+55)?\s*\(?(?:[1-9]{2})\)?\s*(?:9\s*)?[0-9]{4}\s*-?\s*[0-9]{4}$/.test(
            v
          ) || "Número inválido",
      ],
      emailRules: [(v) => /\S+@\S+\.\S+/.test(v) || "E-mail inválido"],
      userAd: this.$store.getters["auth/userAd"],
      loggedUser: this.$store.getters["auth/userName"],
    };
  },

  watch: {
    phone: function (val) {
      this.phone = val.replace(/\D/g, "");
    },
  },

  async created() {
    await this.validateUser();
  },

  methods: {
    async submit() {
      try {
        this.updateContactIfNeeded();

        await Collaborator.updateContact(this.contact);
        this.$toast.success("Contato atualizado com sucesso!");
        setTimeout(() => this.$router.push({ path: "/home" }), 1000);
      } catch (e) {
        this.$handleHttpError(e);
      }
    },

    async validateUser() {
      console.log(this.userAd);
      const collaborator = await Collaborator.getContact(this.userAd);
      this.contact = {
        user: this.userAd,
        name: this.loggedUser,
        ...collaborator,
      };

      if (this.contact !== null) {
        this.phone = this.contact.phone;
        this.email = this.contact.email;
      }
    },

    updateContactIfNeeded() {
      if (
        this.phone !== this.contact.phone ||
        this.email !== this.contact.email
      ) {
        this.contact.phone = this.phone;
        this.contact.email = this.email;
      }
    },
  },
};
</script>